// Module
var code = "<h3>Add Organisation</h3> <div class=\"card\"> <h5>Add Organisation</h5> <hr/> <div id=\"org-form\" class=\"grid pt-8\"> </div> </div> <div class=\"flex justify-end items-center\"> <button id=\"\" onclick=\"thsPage.addOrg()\" class=\"mt-8\">Add Organisation</button> </div> ";
// Exports
export default code;